<template>
  <div>
    <!-- 服务标准 -->
    <div class="standard">
      <div class="img_box">
        <img :src="standardObj.img" class="img_cover" alt="" />
      </div>
      <div class="text_box">
        <div class="min_text_box">
          <div class="title">{{ standardObj.title }}</div>
          <div class="info">{{ standardObj.info }}</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    standardObj: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      standard: {
        img: require("../../assets/components_img/temporary/biaozhun.png"),
        title: "用心服务  优质服务  高效服务",
        info:
          "每一份信赖都值得认真对待，公司坚持将客户利益放在首位，通过配备专业的售前、售中、售后团队，对项目全流程实施动态跟踪，持续优化客户体验。",
      },
    };
  },
};
</script>

<style scoped lang='scss'>
.standard {
  // width: 100%;
  width: 1200px;
  // height: 406px;
  height: 40.6vh;
  // margin-top: 83px;
  margin-top: 8.3vh;
  // margin-bottom: 91px;
  margin-bottom: 9.1vh;
  position: relative;
  .img_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 856px;
    // height: 322px;
    height: 32.2vh;
    border: 1px solid #0fffff;
    z-index: 2;
  }
  .text_box {
    width: 862px;
    // height: 330px;
    height: 33vh;
    position: absolute;
    bottom: 0;
    right: 0;
    border: 1px solid #0fffff;
    z-index: 1;
    .min_text_box {
      position: absolute;
      right: 41px;
      // bottom: 41px;
      bottom: 4.1vh;
      width: 260px;
      .line {
        width: 40px;
        height: 4px;
        // margin-top: 35px;
        margin-top: 3.5vh;
        background: #0fffff;
        float: right;
      }
      .title {
        width: 100%;
        // height: 24px;
        height: 2.4vh;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        // line-height: 20px;
        line-height: 2vh;
        color: #ffffff;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .info {
        width: 100%;
        white-space: pre-wrap;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        // line-height: 28px;
        line-height: 2.8vh;
        color: #ffffff;
        // margin-top: 40px;
        margin-top: 4vh;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>